import { useContext, useEffect, useId } from "react";
import { DataContext } from "../../context/DataContext";
import {
  Toast,
  ToastBody,
  Toaster,
  ToastIntent,
  ToastTitle,
  useToastController,
} from "@fluentui/react-components";

export const Toastify = (): JSX.Element => {
  const dataContext = useContext(DataContext);
  const { message } = dataContext.state;
  const toasterId = useId();
  const { dispatchToast } = useToastController(toasterId);
  const toastify = (title: string, intent: ToastIntent, text: string) => {
    dispatchToast(
      <Toast>
        <ToastTitle>{title}</ToastTitle>
        {text && <ToastBody>{text}</ToastBody>}
      </Toast>,
      { intent }
    );
  };
  useEffect(() => {
    if (message) {
      toastify(message.title, message.intent, message?.text);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message]);
  return <Toaster pauseOnHover position="top-end" toasterId={toasterId} />;
};
